
import SchemaTreeSelector from './SchemaTreeSelector';

export default SchemaTreeSelector;
